<div class="wrapper__contentComponent--expediente container my-5">
  <h3 class="h4-tipografia-govco text-center">Gestión de videos</h3>
  <!-- Form for adding new videos -->
  <div class="mt-4 w-50 mx-auto">
    <form [formGroup]="videoForm" (ngSubmit)="processVideoUpload()">
      <div class="mb-3">
        <label for="videoName" class="form-label">Nombre del video</label>
        <input
          type="text"
          class="form-control"
          id="videoName"
          formControlName="videoName" />
        <div
          *ngIf="
            videoForm.get('videoName')?.invalid &&
            videoForm.get('videoName')?.touched
          "
          class="text-danger">
          El nombre del video es requerido.
        </div>
      </div>
      <div class="mb-3">
        <label for="videoUrl" class="form-label">URL del video</label>
        <input
          type="text"
          class="form-control"
          id="videoUrl"
          formControlName="videoUrl" />
        <div
          *ngIf="
            videoForm.get('videoUrl')?.invalid &&
            videoForm.get('videoUrl')?.touched
          "
          class="text-danger">
          La URL del video es requerida.
        </div>
      </div>
      <button
        type="submit"
        class="btn-govco fill-btn-govco mx-auto"
        [disabled]="videoForm.invalid">
        Subir video
      </button>
    </form>
  </div>
  <!-- List of videos -->
  <div class="video-management-container mt-4">
    <div class="video-header mb-3">
      <h4 class="h5-tipografia-govco">
        Actualizar Link's de videos de configuración Justino
      </h4>
    </div>
    <div class="video-list">
      <div
        class="video-item p-3 mb-2 bg-light rounded"
        *ngFor="let video of videos; let i = index">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
          <div class="mb-2 mb-md-0">
            <div class="video-title fw-bold mb-1">
              Link: {{ i + 1 }} {{ video.Nombre }}
            </div>
            <a
              [href]="video.videoUrl"
              target="_blank"
              class="video-url text-primary text-break">
              {{ video.videoUrl }}
            </a>
          </div>
          <div
            class="d-flex flex-column flex-md-row gap-3 align-items-start align-items-md-center">
            <button
              class="btn-govco fill-btn-govco d-flex align-items-center mt-2 mt-md-0"
              (click)="updateVideoInfo(video)">
              <i class="bi bi-cloud-arrow-up me-2"></i>
              Actualizar link
            </button>
            <button
              class="btn-govco fill-btn-govco d-flex align-items-center mt-2 mt-md-0"
              (click)="openConfirmationDeleteVideoAlert(video.Id)">
              <i class="bi bi-cloud-arrow-up me-2"></i>
              Eliminar link
            </button>
          </div>
        </div>
      </div>
      <!-- Show message when no videos are available -->
      <div *ngIf="videos.length === 0" class="text-center p-4">
        <p>No hay videos disponibles.</p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="modalUpdate">
  <app-modal-editar-video
    [elements]="videos"
    (updateEmitter)="updateVideo($event)"></app-modal-editar-video>
</div>
